/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2019-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

/**
 * A container for the OverlayTrigger component which can be used if we want to render
 * a text with a tooltip. This is the use-case that we need for now, but it can be
 * expanded to cover more cases.
 */
export default class TextWithTooltip extends Component {
    render() {
        const { id, trigger=['hover', 'focus'], placement='right', text=null, tooltipText, spanClassName, wordBreak='normal' } = this.props;
        const tooltip = <Tooltip style={{maxWidth: 300, wordBreak: `${wordBreak}`}} id={`${id}-tooltip`}>{tooltipText || text}</Tooltip>;
        return (
            <OverlayTrigger trigger={trigger} placement={placement} overlay={tooltip}>
                <span className={spanClassName}>{text}</span>
            </OverlayTrigger>
        )
    }
}

TextWithTooltip.propTypes = {
    id: PropTypes.string.isRequired,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    trigger: PropTypes.arrayOf(PropTypes.string),
    placement: PropTypes.string,
    tooltipText: PropTypes.string,
    spanClassName: PropTypes.string
};
